import jwtDecode from 'jwt-decode'
import moment from 'moment'
import * as constants from '../mixins/constants'
import i18n from '../plugins/i18next'
import {
  cleanPathsData,
  formatTimeCalendar,
  getMaxStopPointByService,
  setItemStorage,
  weakKey
} from '../plugins/util'
import {
  createOrderV3Partner,
  createOrderV3User,
  estimatedFeeV3Partner,
  estimatedFeeV3User,
  cancelV3Partner,
  cancelV3User
} from '../store/api/order'

const { pick, find } = require('@/plugins/lodash')

export const updateOrderInfo = (order, { service, locale, currentUserId, localeSuffix }) => {
  if (order.supplier_id) {
    order.order_avatar = `${process.env.VUE_APP_API_URL}${constants.API.supplier.file}?id=${order.supplier_id}&file_id=avatar&size=128`
    // order.supplier_avatar = `${process.env.VUE_APP_API_URL}${constants.API.supplier.file}?id=${order.supplier_id}&file_id=avatar&size=128`
  } else {
    order.order_avatar = service && service.icon_url
  }

  // format order time: show only in cases: cancel, complete, failed
  order.format_order_time = (order.order_time && formatTimeCalendar(order.order_time, locale)) || ''
  order.format_idle_time = (order.idle_until && formatTimeCalendar(order.idle_until)) || ''
  order.format_cancel_time = (order.cancel_time && formatTimeCalendar(order.cancel_time)) || ''
  order.format_accept_time = (order.accept_time && formatTimeCalendar(order.accept_time)) || ''
  order.format_board_time = (order.board_time && formatTimeCalendar(order.board_time)) || ''
  order.format_pickup_time = (order.pickup_time && formatTimeCalendar(order.pickup_time)) || ''
  order.format_complete_time =
    (order.complete_time && formatTimeCalendar(order.complete_time)) || ''
  order.format_create_time = (order.create_time && formatTimeCalendar(order.create_time)) || ''

  const returnTime = order.path[0].return_time || order.return_time
  order.format_return_time = (returnTime && formatTimeCalendar(returnTime)) || ''

  order.status_time = order.format_cancel_time || order.format_complete_time

  // if (user of another employee made order)
  if (order.user_id !== currentUserId) {
    order.order_of_child = true
  }
  order.currency_symbol = constants.CURRENCY_SYMBOL[order.currency]
  // if show rating
  if (order.status === constants.ORDER_STATUS.COMPLETED) {
    order.show_rating = true
  }

  order.service_name = service && (service['name' + localeSuffix] || service.name)
  order.service_icon = service && service.icon_url

  // status label
  order.status_label = i18n.t('order_status.' + order.status.split(' ').join('_'))

  var totalCOD = 0
  order.path.forEach((p) => {
    totalCOD += p.cod || 0
  })
  order.total_cod = totalCOD

  let hasFailedStoppoint = false
  order.path.forEach((point, index) => {
    if (index === 0) {
      point.root = true
    }

    if (point.fail_comment) {
      // const comment = point.fail_comment
      // Hidden fail comment due AP-79
      // if (comment.indexOf('OTHERS - ') > -1) {
      // 	point.fail_comment_label = comment
      // } else if (comment === 'PACKAGE DOES NOT MATCH RECIPIENT\'S REQUEST') {
      // 	point.fail_comment_label = i18n.t('record.fail_comment.PACKAGE_DOES_NOT_MATCH_RECIPIENTS_REQUEST')
      // } else {
      // 	point.fail_comment_label = i18n.t('record.fail_comment.' + comment.split(' ').join('_'))
      // }

      const fail_time = point.fail_time || new Date().getTime() / 1000
      point.format_fail_time = formatTimeCalendar(fail_time)
    }

    if (point.complete_time) {
      point.format_complete_time = formatTimeCalendar(point.complete_time)
    }

    if (point.status === constants.ORDER_STATUS.FAILED) {
      hasFailedStoppoint = true
    }
  })

  if (
    order.notify_package_return === true &&
    order.status === constants.ORDER_STATUS.COMPLETED &&
    hasFailedStoppoint
  ) {
    const returnTime = order.path[0].return_time || order.return_time
    order.returning_status_label = {
      returned: returnTime && true
    }
  }

  if (
    order.notify_package_return === true &&
    order.status === constants.ORDER_STATUS.COMPLETED &&
    order.path[0].por_type === 'document'
  ) {
    const statusMapping = {
      IN_RETURN: { returned: false },
      RETURNED: { returned: true }
    }

    if (statusMapping[order.sub_status]) {
      order.returning_docs_status_label = statusMapping[order.sub_status]
    }
  }
}
const formatTime = (time) => {
  return moment.unix(time).format('DD-MM-Y, HH:mm')
}

const exportFields = [
  '_id',
  'format_create_time',
  'format_order_time',
  'format_board_time',
  'format_pickup_time',
  'format_complete_time',
  'format_cancel_time',
  'service_name',
  'user_id',
  'user_name',
  'status_label',
  'request_str',
  'special_request_price',
  'request_value',
  'vat',
  'voucher_discount',
  'format_payment_method',
  'total_price',
  'distance',
  'remarks',
  'origin_address',
  'tags'
]
const totalField = ['additional_fees', 'total_pay']
const extraFields = [
  'statusPath',
  'address',
  'cod',
  'mobile',
  'recipient',
  'comment',
  'nationwide_tracking_number',
  'items'
]
const timeFields = [
  'order_time',
  'cancel_time',
  'board_time',
  'pickup_time',
  'complete_time',
  'create_time'
]
export const pickOrderDataToExport = async (orders) => {
  let data = []
  let maxDropoff = 0

  orders.forEach((item) => {
    const order = pick(item, [...exportFields, 'path'], totalField)
    const tempOrder = pick(item, timeFields)
    order.format_order_time = (tempOrder.order_time && formatTime(tempOrder.order_time)) || ''
    order.format_cancel_time = (tempOrder.cancel_time && formatTime(tempOrder.cancel_time)) || ''
    order.format_board_time = (tempOrder.board_time && formatTime(tempOrder.board_time)) || ''
    order.format_pickup_time = (tempOrder.pickup_time && formatTime(tempOrder.pickup_time)) || ''
    order.format_complete_time =
      (tempOrder.complete_time && formatTime(tempOrder.complete_time)) || ''
    order.format_create_time = (tempOrder.create_time && formatTime(tempOrder.create_time)) || ''

    switch (item.payment_method) {
      case constants.PAYMENT_METHODS.CASH:
        order.format_payment_method = i18n.t('payment_method.by_cash')
        break
      case constants.PAYMENT_METHODS.BALANCE:
        order.format_payment_method = i18n.t('payment_method.by_balance')
        break
      case constants.PAYMENT_METHODS.BUSINESS_ACCOUNT:
        order.format_payment_method = i18n.t('payment_method.by_business_account')
        break
      case constants.PAYMENT_METHODS.CASH_BY_RECIPIENT:
        order.format_payment_method = i18n.t('payment_method.by_recipient')
        break
      case constants.PAYMENT_METHODS.MOMO:
        order.format_payment_method = i18n.t('payment_method.by_momo')
        break
      case constants.PAYMENT_METHODS.ZALOPAY:
        order.format_payment_method = i18n.t('payment_method.by_zalopay')
        break
      // case constants.PAYMENT_METHODS.SMARTPAY:
      //   order.format_payment_method = i18n.t('payment_method.by_smartpay');
      //   break;
      case constants.PAYMENT_METHODS.VNPAY:
        order.format_payment_method = i18n.t('payment_method.by_vnpay')
        break
      case constants.PAYMENT_METHODS.VIETTELPAY:
        order.format_payment_method = i18n.t('payment_method.by_viettelpay')
        break
      case constants.PAYMENT_METHODS.SHOPEEPAY:
        order.format_payment_method = i18n.t('payment_method.by_shopeepay')
        break
      case constants.PAYMENT_METHODS.VPBANK:
        order.format_payment_method = i18n.t('payment_method.by_vpbank')
        break
      default:
        order.format_payment_method = ''
    }

    order.request_str = order.requests ? order.requests.map((rq) => rq.name).join('\n') : ''
    order.origin_address =
      (order.path && order.path[0] && order.path[0].address) ||
      (order.path && order.path[0] && order.path[0].formatted_address) ||
      ''
    order.images_str = order.images ? order.images.join('\n') : ''
    order.path.splice(0, 1)
    order.tags = (item.tags && item.tags.join(', ')) || ''

    order.path.forEach((path, index) => {
      order[`statusPath_${index + 1}`] = path.status
      order[`address_${index + 1}`] = path.address || path.formatted_address
      order[`cod_${index + 1}`] = path.cod
      order[`mobile_${index + 1}`] = path.mobile
      order[`recipient_${index + 1}`] = path.name
      order[`comment_${index + 1}`] = path.remarks
      order[`nationwide_tracking_number_${index + 1}`] =
        path.tracking_number || path.nationwide_tracking_number
    })

    data.push(order)
    if (order.path.length > maxDropoff) maxDropoff = order.path.length
  })

  data.forEach((item) => {
    const order = pick(item, totalField)

    let totalFee =
      parseInt(
        item.reimbursement && item.reimbursement.total_fee ? item.reimbursement.total_fee : '0'
      ) + parseInt(item.total_price ? item.total_price : '0')
    order.additional_fees =
      item.reimbursement && item.reimbursement.total_fee ? item.reimbursement.total_fee : '0'
    order.total_pay = totalFee
  })

  const headerTitles = {}
  let orderedFields = []

  exportFields.forEach((field) => {
    if (field !== 'path' && field !== 'images_str') {
      headerTitles[field] = i18n.t('records.csv_header.' + field)
      orderedFields.push(field)
    }
  })

  for (let i = 1; i <= maxDropoff; i++) {
    extraFields.forEach((field) => {
      headerTitles[field + '_' + i] = i18n.t('records.csv_header.' + field, {
        dropoff_num: i
      })
      orderedFields.push(field + '_' + i)
    })
  }

  totalField.forEach((field) => {
    headerTitles[field] = i18n.t('records.csv_header.' + field)
    orderedFields.push(field)
  })

  data.forEach((order) => {
    orderedFields.push('additional_fees', 'total_pay')
    const finalOrder = {}
    orderedFields.forEach((field) => {
      finalOrder[field] = order[field]
    })
    order = finalOrder
  })

  const finalHeader = {}
  orderedFields.forEach((field) => {
    finalHeader[field] = headerTitles[field]
  })

  data.unshift(finalHeader)
  return data
}

export const downloadFile = async (data, params, fileFormat = null) => {
  if (data) {
    let timeRange = ''
    if (params.from_time && params.to_time) {
      const fromTime = moment.unix(params.from_time).format('YYYY-MM-DD')
      const toTime = moment.unix(params.to_time).format('YYYY-MM-DD')

      if (fromTime === toTime) {
        timeRange = `_${fromTime}`
      } else {
        timeRange = `_${fromTime}_${toTime}`
      }
    }

    const now = moment().format('YYYY-MM-DD HH:mm:ss')
    const XLSX = await new Promise((resolve) => {
      import(/* webpackMode: "lazy" */ 'xlsx').then((module) => {
        resolve(module)
      })
    })

    if (fileFormat !== null && fileFormat === 'csv') {
      const ws = XLSX.utils.json_to_sheet(data, {
        header: exportFields,
        skipHeader: true
      })
      const blob = new Blob(['\ufeff' + XLSX.utils.sheet_to_csv(ws)], {
        type: 'application/octet-stream'
      })

      let filename = `order_report${timeRange} ${now}.csv`
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        var link = document.createElement('a')
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style = 'visibility:hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    } else {
      const ws = XLSX.utils.json_to_sheet(data, {
        skipHeader: true
      })
      const filename = `order_report${timeRange}-${now}.xlsx`
      var workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, ws, 'History Order')
      XLSX.writeFile(workbook, filename, {})
    }
  }
}

export const updateRequirePodByKAProfile = (path, kaProfile) => {
  let result = [...path]

  const orderTemplate = kaProfile && kaProfile.ro_settings && kaProfile.ro_settings.order_template

  if (orderTemplate) {
    const { pickup, dropoff } = orderTemplate

    if (pickup) {
      result[0] = Object.assign(result[0], pickup)
    }

    if (dropoff && result.length > 1) {
      result.forEach((p, index) => {
        if (index > 0) {
          p = Object.assign(p, dropoff)
        }
      })
    }
  }

  return result
}

// legacy_getOrderRequestParams for new UI
// Note: some logic is handled by validate/update through ui components
//  - check method is allowed by service
//  - check valid cod - max cod (store.getters.isValidOrderForm)
export const legacy_getOrderRequestParams = (
  // orderForm state
  state,
  kaProfile
) => {
  let path = updateRequirePodByKAProfile(state.path, kaProfile)
  path = cleanPathsData(path)

  // Update valid orderTime
  let orderTime = state.orderTime
  let idleUntil = null

  if (state.service.advance_broadcast_distance == 0) {
    orderTime = 0
  } else {
    const diff = orderTime ? moment.unix(orderTime) - moment() : 0
    if (diff >= constants.MIN_IDLE_UNTIL_MILLISECONDS) {
      idleUntil = orderTime
    } else {
      orderTime = 0
    }
  }

  let requests = []

  // Remove invalid selected additional requests. Case: user change service after select additional requests
  if (state.service && state.service.requests && state.service.requests.length > 0) {
    state.requests.forEach((rq) => {
      const isValid = find(state.service.requests, { _id: rq._id })
      if (isValid) {
        requests.push(rq)
      }
    })
  }

  let params = {
    order_time: orderTime,
    remarks: state.remarks,
    service_id: state.service._id,
    payment_method: state.payment_method,
    promo_code: state.promoCode,
    total_pay: state.estimatedFee.total_pay,
    path: JSON.stringify(path),
    requests: JSON.stringify(requests),
    images: JSON.stringify(state.images)
  }
  if (idleUntil) {
    params.idle_until = idleUntil
  }

  if (state.estimatedFee.promo_error_message) {
    delete params.promo_code
  }

  // console.log('params', params)

  return params
}

const checkPODRequestValid = ({ userProfile, path, podRequest, totalStoppoints }) => {
  const isSME = userProfile && userProfile.user_type === constants.USER_TYPE.SME
  const isPODRequestEnable = podRequest.enable
  const podAppliedStpNum = podRequest.applied_stp_num

  let totalCOD = 0

  path.forEach((p) => {
    if (p.cod) {
      totalCOD += p.cod
    }
  })

  return isSME && totalStoppoints <= podAppliedStpNum && totalCOD !== 0 && isPODRequestEnable
}

export const getOrderRequestParamsByService = (formData, service, options) => {
  const {
    userProfile,
    forEstimateFee,
    estimatedFee,
    shouldStringifyObject,
    usePaymentMethodCash,
    podPaymentMethodList
  } = options || {}
  let params = {}

  if (formData.method_picked) {
    params.method_id = formData.method_picked.method_id
    params.method_type = formData.method_picked.method_type
  }

  const kaProfile = userProfile && userProfile.ka_profile
  let path = updateRequirePodByKAProfile(formData.path, kaProfile)

  const pathLength = path.length
  // check require stoppoints needed to estimate fee/create order
  if (service.require_to) {
    const numOfStoppoint = pathLength - 1
    const maxStoppoint = getMaxStopPointByService(service, userProfile)
    const minStoppoint = service.min_stop_points || 1
    if (numOfStoppoint < minStoppoint || numOfStoppoint > maxStoppoint) {
      params.invalid = true
    }
  } else if (pathLength !== 1) {
    params.invalid = true
  }

  // params.path = shouldStringifyObject ? JSON.stringify(path) : path

  params.remarks = formData.remarks

  params.service_id = service._id

  // check forEstimateFee and validate data
  params.payment_method = usePaymentMethodCash
    ? constants.PAYMENT_METHODS.CASH
    : formData.payment_method

  if (
    formData.promoCode &&
    (forEstimateFee || !estimatedFee || (estimatedFee && !estimatedFee.promo_error_message))
  ) {
    params.promo_code = formData.promoCode
  }

  // Update valid orderTime/Idle time

  if (service.advance_broadcast_distance == 0) {
    params.order_time = 0
  } else {
    const diff = formData.orderTime ? moment.unix(formData.orderTime) - moment() : 0
    const orderTimeFormatted = Math.floor(formData.orderTime)

    if (diff >= constants.MIN_IDLE_UNTIL_MILLISECONDS) {
      params.idle_until = orderTimeFormatted
      params.order_time = orderTimeFormatted
    } else {
      params.order_time = 0
    }
  }

  let isValidPODRequest = false
  const hasPODPaymentMethodList = podPaymentMethodList && podPaymentMethodList.length > 0

  let requests = []

  path = cleanPathsData(path)

  if (service && service.requests && service.requests.length > 0 && formData.requests) {
    formData.requests.forEach((rq) => {
      const validRequest = find(service.requests, { _id: rq._id })
      if (validRequest) {
        if (
          rq.subtype === constants.REQUEST_SUBTYPE.POD ||
          rq._id.includes(constants.REQUEST_SUBTYPE.POD)
        ) {
          isValidPODRequest = checkPODRequestValid({
            userProfile,
            path,
            podRequest: validRequest,
            totalStoppoints: pathLength - 1
          })

          if (isValidPODRequest) {
            requests.push(rq)
          }
        } else {
          requests.push(rq)
        }
      }
    })
  }

  if (isValidPODRequest && hasPODPaymentMethodList) {
    let defaultPaymentCode = ''
    podPaymentMethodList.forEach((method) => {
      if (method.is_default) {
        defaultPaymentCode = method.code
      }
    })

    path.forEach((p) => {
      if (p.cod) {
        p.cod_payment_method = defaultPaymentCode
      }
    })
  }

  // check delivery option request
  const deliveryOptionRequest = getDeliveryOptionRequestObjectFromService(service)
  if (deliveryOptionRequest) {
    formData.path.forEach((point, index) => {
      if (point.delivery_option) {
        // enable delivery option
        const foundIndex = requests.findIndex((s) => {
          return s._id === deliveryOptionRequest._id && index === s.path_index
        })
        if (foundIndex === -1) {
          requests.push({
            _id: deliveryOptionRequest._id,
            price: deliveryOptionRequest.price,
            path_index: index
          })
        }
      } else {
        // disable delivery option
        delete path[index].apt_number
        delete path[index].building

        const foundIndex = requests.findIndex((s) => {
          return s._id === deliveryOptionRequest._id && s.path_index === index
        })
        if (foundIndex >= 0) {
          requests.splice(foundIndex, 1)
        }
      }
    })
  } else {
    // disable delivery option
    path.forEach((p) => {
      delete p.apt_number
      delete p.building
    })
  }

  params.requests = shouldStringifyObject ? JSON.stringify(requests) : requests
  params.path = shouldStringifyObject ? JSON.stringify(path) : path

  if (formData.images) {
    params.images = shouldStringifyObject ? JSON.stringify(formData.images) : formData.images
  }

  if (estimatedFee && !forEstimateFee) {
    params.total_pay = estimatedFee.total_pay
  }

  formData.package_detail &&
    formData.package_detail.forEach((item) => {
      if (!item.height) {
        item.height = 0
      }
      if (!item.length) {
        item.length = 0
      }
      if (!item.weight) {
        item.weight = 0
      }
      if (!item.width) {
        item.width = 0
      }
      if (!item.size) {
        item.size = ''
      }
    })

  params.package_detail = shouldStringifyObject
    ? JSON.stringify(formData.package_detail)
    : formData.package_detail

  if (formData.allowed_vehicles && formData.allowed_vehicles.length > 0) {
    params.allowed_vehicles = formData.allowed_vehicles
  } else {
    delete params.allowed_vehicles
  }

  return params
}

export const getSuggestRequestParamsByService = (formData, service, options) => {
  const {
    userProfile,
    forEstimateFee,
    estimatedFee,
    shouldStringifyObject,
    usePaymentMethodCash,
    podPaymentMethodList
  } = options || {}
  let params = {}

  // const kaProfile = userProfile && userProfile.ka_profile
  // console.log('userProfile', userProfile)
  let path = formData.path
  const pathLength = path.length
  // check require stoppoints needed to estimate fee/create order

  // params.path = shouldStringifyObject ? JSON.stringify(path) : path

  params.service_id = service._id

  // check forEstimateFee and validate data
  params.payment_method = usePaymentMethodCash
    ? constants.PAYMENT_METHODS.CASH
    : formData.payment_method

  if (
    formData.promoCode &&
    (forEstimateFee || !estimatedFee || (estimatedFee && !estimatedFee.promo_error_message))
  ) {
    params.promo_code = formData.promoCode
  }

  // Update valid orderTime/Idle time

  if (service.advance_broadcast_distance == 0) {
    params.order_time = 0
  } else {
    const diff = formData.orderTime ? moment.unix(formData.orderTime) - moment() : 0
    if (diff >= constants.MIN_IDLE_UNTIL_MILLISECONDS) {
      params.idle_until = formData.orderTime
      params.order_time = formData.orderTime
    } else {
      params.order_time = 0
    }
  }

  let isValidPODRequest = false
  const hasPODPaymentMethodList = podPaymentMethodList && podPaymentMethodList.length > 0

  let requests = []

  // path = cleanPathsData(path)

  if (service && service.requests && service.requests.length > 0 && formData.requests) {
    formData.requests.forEach((rq) => {
      const validRequest = find(service.requests, { _id: rq._id })
      if (validRequest) {
        if (
          rq.subtype === constants.REQUEST_SUBTYPE.POD ||
          rq._id.includes(constants.REQUEST_SUBTYPE.POD)
        ) {
          isValidPODRequest = checkPODRequestValid({
            userProfile,
            path,
            podRequest: validRequest,
            totalStoppoints: pathLength - 1
          })

          if (isValidPODRequest) {
            requests.push(rq)
          }
        } else {
          requests.push(rq)
        }
      }
    })
  }

  if (isValidPODRequest && hasPODPaymentMethodList) {
    let defaultPaymentCode = ''
    podPaymentMethodList.forEach((method) => {
      if (method.is_default) {
        defaultPaymentCode = method.code
      }
    })

    path.forEach((p) => {
      if (p.cod) {
        p.cod_payment_method = defaultPaymentCode
      }
    })
  }

  // check delivery option request
  const deliveryOptionRequest = getDeliveryOptionRequestObjectFromService(service)
  if (deliveryOptionRequest) {
    formData.path.forEach((point, index) => {
      if (point.delivery_option) {
        // enable delivery option
        const foundIndex = requests.findIndex((s) => {
          return s._id === deliveryOptionRequest._id && index === s.path_index
        })
        if (foundIndex === -1) {
          requests.push({
            _id: deliveryOptionRequest._id,
            price: deliveryOptionRequest.price,
            path_index: index
          })
        }
      } else {
        // disable delivery option
        delete path[index].apt_number
        delete path[index].building

        const foundIndex = requests.findIndex((s) => {
          return s._id === deliveryOptionRequest._id && s.path_index === index
        })
        if (foundIndex >= 0) {
          requests.splice(foundIndex, 1)
        }
      }
    })
  } else {
    // disable delivery option
    path.forEach((p) => {
      delete p.apt_number
      delete p.building
    })
  }

  params.requests = shouldStringifyObject ? JSON.stringify(requests) : requests
  params.path = shouldStringifyObject ? JSON.stringify(path) : path

  if (formData.images) {
    params.images = shouldStringifyObject ? JSON.stringify(formData.images) : formData.images
  }

  if (estimatedFee && !forEstimateFee) {
    params.total_pay = estimatedFee.total_pay
  }

  formData.package_detail &&
    formData.package_detail.forEach((item) => {
      if (!item.heigth) {
        item.heigth = 0
      }
      if (!item.length) {
        item.length = 0
      }
      if (!item.weigth) {
        item.weigth = 0
      }
      if (!item.width) {
        item.width = 0
      }
      if (!item.size) {
        item.size = ''
      }
    })

  params.package_detail = shouldStringifyObject
    ? JSON.stringify(formData.package_detail)
    : formData.package_detail

  if (formData.allowed_vehicles && formData.allowed_vehicles.length > 0) {
    params.allowed_vehicles = formData.allowed_vehicles
  } else {
    params.allowed_vehicles = null
  }

  return params
}

export const getOrderDataToReuse = (order, service) => {
  let cleanPath = []

  const deliveryOptionRequest = getDeliveryOptionRequestObjectFromService(service) || {}
  const selectedDeliveryOptionRequests = (order.requests || []).filter((r) => {
    return r._id === deliveryOptionRequest._id
  })
  order.requests = (order.requests || []).filter((r) => {
    return r._id !== deliveryOptionRequest._id
  })

  order.path.forEach((point, index) => {
    point.is_valid = true
    point.weakKey = weakKey({ merchant: point.address })

    const foundIndex = selectedDeliveryOptionRequests.findIndex((s) => {
      return s.path_index === index
    })
    if (foundIndex >= 0) {
      point.delivery_option = true
    } else {
      delete point.delivery_option
    }

    if (
      order.package_detail &&
      order.service &&
      order.service.delivery_type === constants.DELIVERY_TYPE.NATIONWIDE &&
      index > 0
    ) {
      point.package_detail = order.package_detail[0]
    }

    cleanPath.push(
      pick(point, [
        'address',
        'formatted_address',
        'lat',
        'lng',
        'short_address',
        'name',
        'mobile',
        'remarks',
        'types',
        'is_valid',
        'tracking_number',
        'require_pod',
        'pod_type',
        'weight',
        'note_code',
        'district_id',
        'ward_code',
        'insurance_fee',
        'apt_number',
        'building',
        'delivery_option',
        'address_code',
        'items',
        'item_description',
        'item_descriptions',
        'first_label',
        'second_label',
        'weakKey',
        'shipping_type',
        'pop_type',
        'pod_type',
        'pof_type',
        'require_pop',
        'require_pod',
        'require_pof',
        'partner',
        'cod',
        'level',
        'package_detail',
        'adr_source'
      ])
    )
  })
  let cleanRequests = []
  if (order.requests) {
    order.requests.forEach((request) => {
      // TODO:  chổ này sau có item_value thì xoá đk shouldApplyAhaProInsuranceRequest
      const shouldApplyAhaProInsuranceRequest = order.path.some((path) => path.item_value)
      const cleanRequest = pick(request, [
        '_id',
        'value',
        'num',
        'price',
        'price_item',
        'type',
        'path_index',
        'tier_code',
        'option_code',
        'option_detail'
      ])

      if (request.required_item_value) {
        if (shouldApplyAhaProInsuranceRequest) {
          cleanRequests.push(cleanRequest)
        }
      } else {
        cleanRequests.push(cleanRequest)
      }
    })
  }

  // const numPath = order.path.length

  const newOrderFormState = {
    path: cleanPath || [],
    service: service || {},
    requests: cleanRequests,
    remarks: order.remarks || '',
    orderTime: parseInt(order.order_time) || 0,
    images: order.images || [],
    promoCode: order.promo_code,

    estimateFeeTimeout: null,
    estimatedFee: {},
    estimatingFee: false,
    estimateFeeError: null,
    creatingOrder: false,

    package_detail: order.package_detail || [],
    payment_method: order.payment_method,
    method_picked: order.payment_details || null,
    allowed_vehicles: order.allowed_vehicles || null
  }
  // if (order.service && !order.service.require_to && numPath > 1) {
  //   newOrderFormState.path = [newOrderFormState.path[numPath - 1]]
  // }
  if (service.delivery_type === constants.DELIVERY_TYPE.TRUCK) {
    newOrderFormState.orderTruckService = service
  }

  return newOrderFormState
}

export const getDeliveryOptionRequestObjectFromService = (service) => {
  const requests =
    service &&
    service.requests &&
    service.requests.filter((r) => {
      return r.delivery_option === true
    })
  return requests && requests[0]
}

export const parseHTTPStatusCode = (str) => {
  let code = 400 // set default status code 400

  if (str) {
    const regex = /^\d{3}/gim
    const matches = str.toString().match(regex) || []

    if (matches[0] && !isNaN(matches[0])) code = parseInt(matches[0])
  }

  return code
}
export const transformEstimateFeeV2Error = (raw = {}) => {
  return {
    _id: raw._id,
    isError: true,
    status: parseHTTPStatusCode(raw.http_code),
    data: { ...raw }
  }
}
export const transformEstimateFeeV3Error = (raw = {}) => {
  return {
    _id: raw.service_id,
    isError: true,
    status: raw.error && raw.error.http_code,
    data: { ...raw.error }
  }
}

// Middleware to handle data from estimateFeeV2 api

export const estimateFeeV2Middleware =
  // eslint-disable-next-line prettier/prettier


    (config = {}) =>
    (func) => {
      const { targetDataId = null, targetDataIndex = null } = config

      return new Promise((resolve, reject) => {
        func
          .then((data) => {
            if (data && Array.isArray(data) && data.length > 0) {
              if (targetDataId || targetDataIndex || targetDataIndex === 0) {
                // Check target data to resolve/reject
                let item
                if (!item && targetDataId) {
                  item = data.find((i) => i._id === targetDataId)
                }

                if (!item && (targetDataIndex || targetDataIndex === 0)) {
                  item = data[targetDataIndex]
                }

                if (item && item.title) return reject(transformEstimateFeeV2Error(item))
                else return resolve(item)
              } else {
                // Transform all existed error
                // then resolve data as same as normal flow
                const _data = data.map((item) => {
                  if (item.title) {
                    return transformEstimateFeeV2Error(item)
                  } else return item
                })

                return resolve(_data)
              }
            } else {
              return resolve(data)
            }
          })
          .catch((e) => {
            const error = (e && e.response) || (e && e.error) || null
            return reject(error)
          })
      })
    }

// Middleware to handle data from estimateFeeV3 api
export const estimateFeeV3Middleware =
  (config = {}) =>
  (func) => {
    const { targetDataId = null, targetDataIndex = null } = config

    return new Promise((resolve, reject) => {
      func
        .then((data) => {
          if (data && Array.isArray(data) && data.length > 0) {
            if (targetDataId || targetDataIndex || targetDataIndex === 0) {
              // Check target data to resolve/reject
              let item
              if (!item && targetDataId) {
                item = data.find((i) => i.service_id === targetDataId)
              }

              if (!item && (targetDataIndex || targetDataIndex === 0)) {
                item = data[targetDataIndex]
              }

              if (!item)
                return reject(
                  transformEstimateFeeV3Error({
                    service_id: targetDataId
                  })
                )

              if (item && item.error && !item.data) {
                return reject(transformEstimateFeeV3Error(item))
              } else {
                return resolve({ _id: item.service_id, ...item.data })
              }
            } else {
              // Transform all existed error
              // then resolve data as same as normal flow
              const _data = data.map((item) =>
                item.error && !item.data
                  ? transformEstimateFeeV3Error(item)
                  : { _id: item.service_id, ...item.data }
              )

              return resolve(_data)
            }
          } else {
            return resolve(data)
          }
        })
        .catch((e) => {
          const error = (e && e.response) || (e && e.error) || null
          return reject(error)
        })
    })
  }
export const transformEstimateFeeGWError = (raw = {}) => {
  return {
    _id: raw._id,
    isError: true,
    status: parseHTTPStatusCode(raw.http_code),
    data: { ...raw }
  }
}
export const estimateFeeGWMiddleware =
  (config = {}) =>
  (func) => {
    const { targetDataId = null, targetDataIndex = null } = config

    return new Promise((resolve, reject) => {
      func
        .then((data) => {
          if (data && Array.isArray(data) && data.length > 0) {
            if (targetDataId || targetDataIndex || targetDataIndex === 0) {
              // Check target data to resolve/reject
              let item
              if (!item && targetDataId) {
                item = data.find((i) => i._id === targetDataId)
              }

              if (!item && (targetDataIndex || targetDataIndex === 0)) {
                item = data[targetDataIndex]
              }

              if (item && item.title) return reject(transformEstimateFeeGWError(item))
              else return resolve(item)
            } else {
              // Transform all existed error
              // then resolve data as same as normal flow
              const _data = data.map((item) => {
                if (item.title) {
                  return transformEstimateFeeGWError(item)
                } else return item
              })

              return resolve(_data)
            }
          } else {
            return resolve(data)
          }
        })
        .catch((e) => {
          const error = (e && e.response) || (e && e.error) || null
          return reject(error)
        })
    })
  }

export function getPartnerFromToken({ $store }) {
  const token = $store.getters.token

  if (!token) {
    return null
  }

  try {
    const decodeToken = jwtDecode(token)
    let partnerFromToken = {
      isPartner: false,
      partner: null
    }

    if (decodeToken && decodeToken.partner) {
      partnerFromToken = {
        isPartner: true,
        partner: decodeToken.partner
      }
    }

    setItemStorage(
      constants.LOCAL_STORAGE_KEY__PARTNER_GET_FROM_TOKEN,
      JSON.stringify(partnerFromToken)
    )

    $store.dispatch('setPartnerFromToken', partnerFromToken)

    return partnerFromToken
  } catch (error) {
    console.error('Error while decoding token or setting partner:', error)
  }
}

function executeBasedOnPartner(isPartner = false, partnerFn, userFn, params) {
  try {
    return isPartner ? partnerFn(params) : userFn(params)
  } catch (error) {
    console.log(`Error executing ${isPartner ? 'partner' : 'user'} function:`, error)
    throw error
  }
}

export function useEstimateFeeV3(isPartner = false, params = {}) {
  return executeBasedOnPartner(isPartner, estimatedFeeV3Partner, estimatedFeeV3User, params)
}

export function useCreateOrderV3(isPartner = false, params = {}) {
  return executeBasedOnPartner(isPartner, createOrderV3Partner, createOrderV3User, params)
}

export function useCancelOrderV3(isPartner = false, params = {}) {
  return executeBasedOnPartner(isPartner, cancelV3Partner, cancelV3User, params)
}

export function prepareInsuranceRequest(state) {
  const isEnableInsurance = state.insuranceService.isEnable

  const reorderIncludeInsurance = state.requests.some(
    (req) => req.type && req.type.includes(constants.SERVICE_REQUESTS.INSURANCE)
  )

  if (reorderIncludeInsurance && !isEnableInsurance) {
    state.requests = state.requests.filter(
      (req) => !(req.type && req.type.includes(constants.SERVICE_REQUESTS.INSURANCE))
    )
  }

  if (!state.service.requests) {
    return []
  }

  const insuranceRequest = state.service.requests.find(
    (req) => req.type && req.type.includes(constants.SERVICE_REQUESTS.INSURANCE)
  )

  if (!insuranceRequest || !isEnableInsurance || reorderIncludeInsurance) {
    return []
  }

  return [{ _id: insuranceRequest._id, num: undefined }]
}
